import ImprovementsTable from 'components/content/making-uploads-faster/ImprovementsTable';
import * as React from 'react';
export default {
  ImprovementsTable,
  React
};